'use client';

import { event } from '@/app/lib/analytics/ga';
import { getTailframesFigmaUrl, getTailframesReactComponentGithubUrl, getTailframesStorybookUrl } from '@/app/lib/utils/url';
import ArrowRightIcon from '@/app/ui/assets/icons/arrow-right-icon';
import FigmaIcon from '@/app/ui/assets/icons/figma-icon';
import GitHubIcon from '@/app/ui/assets/icons/github-icon';
import StorybookIcon from '@/app/ui/assets/icons/storybook-icon';
import { Button } from '@/app/ui/components/atoms/button';

interface Props {
  name: string;
  hasSubcomponents?: boolean;
  figmaNodeId?: string;
}

export const ComponentPreviewLinks = ({ name, hasSubcomponents, figmaNodeId }: Props) => {
  return (
    <div className='flex items-center justify-start gap-4'>
      <Button
        size='xsmall'
        target='_blank'
        href={getTailframesReactComponentGithubUrl(name, { isDir: hasSubcomponents })}
        variant='outlined'
        className='mb-1 w-full border-black hover:border-black hover:bg-black hover:text-white sm:w-auto'
        startAdornment={<GitHubIcon className='size-4 fill-black transition duration-300 ease-in-out group-hover:fill-white' />}
        endAdornment={<ArrowRightIcon className='-ml-1 size-4 -rotate-45 stroke-black transition duration-300 ease-in-out group-hover:stroke-white' />}
        onClick={() => {
          event({
            action: 'component_preview_github_source_open',
            category: 'user_interaction',
          });
        }}
      >
        Source Code
      </Button>
      <Button
        size='xsmall'
        target='_blank'
        href={getTailframesStorybookUrl(name)}
        variant='outlined'
        className='mb-1 w-full border-black text-black hover:border-black hover:bg-black hover:text-white sm:w-auto'
        startAdornment={<StorybookIcon className='size-4 stroke-none' />}
        endAdornment={<ArrowRightIcon className='-ml-1 size-4 -rotate-45 stroke-black transition duration-300 ease-in-out group-hover:stroke-white' />}
        onClick={() => {
          event({
            action: 'component_preview_storybook_open',
            category: 'user_interaction',
          });
        }}
      >
        Storybook
      </Button>
      {figmaNodeId && (
        <Button
          size='xsmall'
          target='_blank'
          href={getTailframesFigmaUrl(figmaNodeId)}
          variant='outlined'
          className='mb-1 w-full border-black hover:border-black hover:bg-black hover:text-white sm:w-auto'
          startAdornment={<FigmaIcon className='size-4 stroke-black transition duration-300 ease-in-out group-hover:stroke-white' />}
          endAdornment={<ArrowRightIcon className='-ml-1 size-4 -rotate-45 stroke-black transition duration-300 ease-in-out group-hover:stroke-white' />}
          onClick={() => {
            event({
              action: 'component_preview_figma_open',
              category: 'user_interaction',
            });
          }}
        >
          Figma
        </Button>
      )}
    </div>
  );
};
